import {inject, Injectable} from '@angular/core';
import {HashMap, TranslocoService} from '@jsverse/transloco';
import {ConfirmationService} from 'primeng/api';

export interface ConfirmRequest {
  headerKey: string;
  messageKey: string;
  accept: () => void;
  reject?: () => void;
  messageParams?: HashMap<string | number>;
}

@Injectable({
  providedIn: 'root',
})
export class ConfirmationDialogService {
  private readonly confirmationService = inject(ConfirmationService);
  private readonly translocoService = inject(TranslocoService);

  confirm(request: ConfirmRequest): void {
    this.confirmationService.confirm({
      header: this.translocoService.translate(request.headerKey),
      message: this.translocoService.translate(request.messageKey, request.messageParams ?? {}),
      icon: 'pi pi-exclamation-triangle',
      accept: request.accept,
      reject: request.reject,
    });
  }
}
